import { createSelector } from 'reselect'
import { createGetter, composeGetters } from 'react-redux-getters'
import { fetchMe, replaceMe } from 'actions/me'

export const getMe = createGetter({
  stateSelector: state => state.me,
  asyncFetcher: dispatch => dispatch(fetchMe()),
  stateUpdater: (me, dispatch) => dispatch(replaceMe(me)),
})

export const getUtcOffset = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    me => me.business && me.business.timezoneOffset
  )
)

export const getCurrencyData = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    me => me.business && me.business.currencyData
  )
)
